/* eslint-disable import/first */
import './vendor';
import $ from 'jquery';

import './ofcs';
import './ofcs/escPreventDefault';
import './ofcs/segmentsToLinesConverter';
import './ofcs/segmentsTransformer';
import './ofcs/modal/modal';
import './ofcs/modal/modalFactory';
import './ofcs/modal/modalStack';

// Make sure links with empty hrefs don't reload the current page
$(document).on('click', 'a[href=""]', e => e.preventDefault());
